<template>
  <div class="login-container">
    <div class="login-card">
      <h2 style="padding-bottom: 60px">SEIEI ADMIN 管理システム</h2>
      <el-form :model="form" label-position="top">
        <el-form-item>
          <el-input v-model="form.email" placeholder="メール" size="large">
            <template #prefix>
              <el-icon><User /></el-icon>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="form.password"
            type="password"
            placeholder="パスワード"
            show-password
            size="large"
          >
            <template #prefix>
              <el-icon><Lock /></el-icon>
            </template>
          </el-input>
        </el-form-item>
        <el-button
          @click="login"
          :loading="loading"
          type="primary"
          class="login-button"
          >ログイン</el-button
        >
      </el-form>
      <p v-if="errorMessage" class="error-text">{{ errorMessage }}</p>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
// import { auth, signInWithEmailAndPassword } from "@/firebase";
import { ElMessage } from "element-plus";
// import { Lock, User } from "@element-plus/icons-vue";
import { useRouter } from "vue-router";
import { supabase } from "@/supabase.js";

export default {
  setup() {
    // const form = ref({ email: "test@test.com", password: "123456" });
    const form = ref({ email: "", password: "" });
    const errorMessage = ref("");
    const loading = ref(false);
    const router = useRouter();

    const login = async () => {
      errorMessage.value = "";
      loading.value = true;

      const { error } = await supabase.auth.signInWithPassword({
        email: form.value.email,
        password: form.value.password,
      });
      if (error) {
        ElMessage({
          message: "無効なメールアドレスまたはパスワードです。",
          type: "error",
        });
      } else {
        router.push("/main"); // 登录成功后跳转到 main
      }
      loading.value = false;
      // try {
      //   await supabase.auth.signInWithPassword({
      //     email: form.value.email,
      //     password: form.value.password,
      //   });
      //   router.push("/main"); // 登录成功后跳转到 main
      // } catch (error) {
      //   ElMessage({
      //     message: "無効なメールアドレスまたはパスワードです。",
      //     type: "error",
      //   });
      // } finally {
      //   loading.value = false;
      // }
    };

    return { form, login, errorMessage, loading };
  },
};
</script>

<style lang="stylus" scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #08455d;

}
.login-card {
  width :450px;
  padding : 60px;
  text-align : center;
  background : #08455d;
  color:white;
  border: solid 1px white;
  border-radius: 5px;
}

.login-button {
  // background-color: white;
  // color: #1a5276;
  // font-weight: bold;
  // border-radius: 25px;
  padding: 20px 35px;
  width:100%;
}

.login-button:hover {
  // background-color: #56ABE4;
  // color: white;
}

.error-text {
  color: red;
  margin-top: 10px;
}
</style>
